import React, { Component } from "react";
import { Form, Input, Label, Button } from "../../../Form";

import withTranslations from "../../../../utils/translations/withTranslations";

class SportAnamnese extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="SportAnamnese">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="SportAnamnese__Form"
        >
          <h1>{translate("fiche.sport_anamnese.title")}</h1>

          <Label text={translate("fiche.sport_anamnese.start_sports_practice")} />
          <Input
            name="start_sports_practice"
            defaultValue={data.start_sports_practice}
          />

          <Label text={translate("fiche.sport_anamnese.start_competition")} />
          <Input
            name="start_competition"
            defaultValue={data.start_competition}
          />

          <Label text={translate("fiche.sport_anamnese.training_frequency")} />
          <Input
            name="training_frequency"
            defaultValue={data.training_frequency}
          />

          <Label text={translate("fiche.sport_anamnese.nature")} />
          <Input
            name="nature"
            defaultValue={data.nature}
          />

          <Label text={translate("fiche.sport_anamnese.duration")} />
          <Input
            name="duration"
            defaultValue={data.duration}
          />

          <Label text={translate("fiche.sport_anamnese.other_sports")} />
          <Input
            name="other_sports"
            defaultValue={data.other_sports}
          />

          <Label text={translate("fiche.sport_anamnese.previous_practices")} />
          <Input
            name="previous_practices"
            defaultValue={data.previous_practices}
          />

          <Label text={translate("fiche.sport_anamnese.current_competition_rhythm")} />
          <Input
            name="current_competition_rhythm"
            defaultValue={data.current_competition_rhythm}
          />

          <Label text={translate("fiche.sport_anamnese.competition_results")} />
          <Input
            name="competition_results"
            defaultValue={data.competition_results}
          />

          <Label text={translate("fiche.sport_anamnese.license_revocation")} />
          <Input
            name="license_revocation"
            defaultValue={data.license_revocation}
          />

          <Label text={translate("fiche.sport_anamnese.doping")} />
          <Input
            name="doping"
            defaultValue={data.doping}
          />
          
          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(SportAnamnese);
